import React from "react";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";

export const TREATMENTS = [
  // ---- Skin & Aesthetics ----
  {
    name: "Rejuran Skin Treatment",
    pillar: "Skin & Aesthetics",
    duration: "45 min consult",
    from: "Consultation based",
    body: "A skin-quality treatment administered by a qualified health professional following consultation. Containing polynucleotides derived from salmon DNA, Rejuran is formulated to support overall skin quality — and may assist with texture, hydration, elasticity and resilience. Several sessions may be recommended depending on individual goals, with any potential risks or side effects discussed in private.",
    img: "https://images.pexels.com/photos/3762871/pexels-photo-3762871.jpeg?auto=compress&cs=tinysrgb&w=900&q=85",
  },
  {
    name: "Wrinkle Reduction Treatments",
    pillar: "Skin & Aesthetics",
    duration: "30 min consult",
    from: "Consultation based",
    body: "Fine and expression lines develop naturally around the eyes, forehead, mouth and chin with age. Our qualified practitioners take an individualised approach to wrinkle reduction — softening dynamic lines for a refreshed look, with outcomes and any temporary side effects discussed in private at consultation.",
    img: "https://customer-assets.emergentagent.com/job_derma-studio-2/artifacts/6vc73lud_Beauty%20Aesthetic%20045.jpeg",
  },
  {
    name: "Facial Volume Treatments",
    pillar: "Skin & Aesthetics",
    duration: "45 min consult",
    from: "Consultation based",
    body: "With age, the face may naturally lose structural volume — contributing to hollowing or reduced definition in the cheeks, lips, jawline, chin and nasolabial folds. Our clinicians offer consultations for facial volume treatments that may assist in restoring balance and contour, with results and any temporary swelling or bruising discussed prior to treatment.",
    img: "https://customer-assets.emergentagent.com/job_derma-studio-2/artifacts/8iy4paf9_Beauty%20Aesthetic%20014.jpeg",
  },
  {
    name: "Microneedling",
    pillar: "Skin & Aesthetics",
    duration: "75 min",
    from: "from $290",
    body: "Collagen induction therapy with bespoke serum infusion for texture, scarring and luminosity.",
    img: "https://customer-assets.emergentagent.com/job_derma-studio-2/artifacts/vixr9yl4_Beauty%20Aesthetic%20124.jpeg",
  },
  {
    name: "Acne, Pigmentation & BBL Photorejuvenation",
    pillar: "Skin & Aesthetics",
    duration: "Plan based",
    from: "Consultation based",
    body: "Personalised in-clinic programs combining BBL broadband light therapy, clinical-grade actives and bespoke home rituals. These treatments may address skin concerns including: acne, pigmentation, sun damage, redness and rosacea. Plans are designed at consultation — with sessions, outcomes and any temporary side effects discussed in private.",
    img: "https://images.unsplash.com/photo-1748543668676-ea8241cb3886?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1Mjh8MHwxfHNlYXJjaHwxfHxza2luY2FyZSUyMHNlcnVtJTIwdGV4dHVyZXxlbnwwfHx8fDE3NzgzNzk0NzB8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    name: "Skin Rejuvenation & LED Light Facial",
    pillar: "Skin & Aesthetics",
    duration: "60 min",
    from: "from $220",
    body: "A bespoke rejuvenation facial layering medical-grade peels, calming LED photobiomodulation and Vitamin C-rich masks. May assist in lifting dullness, settling inflammation and restoring a translucent, healthy radiance — with depth tailored to your skin at consultation.",
    img: "https://customer-assets.emergentagent.com/job_derma-studio-2/artifacts/j36iary3_Beauty%20Aesthetic%20121.jpeg",
  },
  {
    name: "Carbon Laser Facial",
    pillar: "Skin & Aesthetics",
    duration: "45 min",
    from: "from $260",
    body: "The 'Hollywood Peel' — activated carbon masque vaporised by Q-switched laser to refine pores, lift congestion and reveal an instant red-carpet glow.",
    img: "https://customer-assets.emergentagent.com/job_derma-studio-2/artifacts/clhodu1s_IMG_0516.jpeg",
  },
  {
    name: "RF Skin Tightening",
    pillar: "Skin & Aesthetics",
    duration: "45–60 min",
    from: "Consultation based",
    body: "Radiofrequency energy delivered to deeper layers of the skin to stimulate collagen and elastin remodelling. Treatments may assist with firmness and laxity across the face, neck, jawline, décolletage and select body areas — typically delivered as a course of sessions, with any temporary warmth or redness discussed prior to treatment.",
    img: "https://images.pexels.com/photos/3373716/pexels-photo-3373716.jpeg?auto=compress&cs=tinysrgb&w=900&q=85",
  },
  {
    name: "Laser Hair Removal",
    pillar: "Skin & Aesthetics",
    duration: "15–60 min",
    from: "from $60",
    body: "Medical-grade diode and Nd:YAG laser hair reduction — safe and effective across all Fitzpatrick skin types, with a fully personalised treatment schedule.",
    img: "https://customer-assets.emergentagent.com/job_derma-studio-2/artifacts/1s25500l_Beauty%20Aesthetic%20037.jpeg",
  },

  // ---- Weight & Metabolic Health ----
  {
    name: "Weight Loss Consultation",
    pillar: "Weight Management",
    duration: "60 min",
    from: "from $190",
    body: "Nurse-led metabolic assessment with pathology review, body composition mapping and a personalised plan — including medical weight-loss pharmacotherapy where appropriate.",
    img: "https://images.unsplash.com/photo-1490645935967-10de6ba17061?auto=format&fit=crop&w=900&q=80",
  },
  {
    name: "Metabolic Review & Follow-Up",
    pillar: "Weight Management",
    duration: "30 min",
    from: "from $110",
    body: "Ongoing fortnightly reviews to track progress, recalibrate nutrition, lifestyle and prescriptions, and keep momentum sustainable.",
    img: "https://images.unsplash.com/photo-1505576399279-565b52d4ac71?auto=format&fit=crop&w=900&q=80",
  },
  {
    name: "Ultrasound Fat Cavitation",
    pillar: "Weight Management",
    duration: "45 min",
    from: "Consultation based",
    body: "Non-invasive body contouring using low-frequency ultrasound waves directed at localised areas of stubborn fat. Treatments may assist with circumference and contour refinement across the abdomen, flanks, thighs and arms — typically delivered as a course of sessions alongside hydration and lifestyle support. Outcomes vary between individuals, with any temporary skin redness or warmth discussed prior to treatment.",
    img: "https://images.pexels.com/photos/3865711/pexels-photo-3865711.jpeg?auto=compress&cs=tinysrgb&w=900&q=85",
  },

  // ---- Women's Health ----
  {
    name: "Women's Health Consultation",
    pillar: "Women's Health",
    duration: "60 min",
    from: "from $210",
    body: "A private appointment for perimenopause, menopause, hormonal skin, libido and energy — with referral pathways into pathology and HRT where indicated.",
    img: "https://customer-assets.emergentagent.com/job_derma-studio-2/artifacts/4mvv0xse_Beauty%20Aesthetic%20071.jpeg",
  },
  {
    name: "Hormonal Skin & Wellness Plan",
    pillar: "Women's Health",
    duration: "Plan based",
    from: "from $390",
    body: "Integrated program blending hormone-aware skincare, nutrition, supplementation and in-clinic treatments for cyclical breakouts and pigmentation.",
    img: "https://customer-assets.emergentagent.com/job_derma-studio-2/artifacts/qrlmrjpn_Beauty%20Aesthetic%20062.jpeg",
  },

  // ---- Hair & Scalp ----
  {
    name: "Scalp & Hair Diagnostic",
    pillar: "Hair & Scalp",
    duration: "45 min",
    from: "from $160",
    body: "Trichoscopy-led scalp analysis, shedding pattern review and a written home and in-clinic protocol for thinning, breakage or irritation.",
    img: "https://images.unsplash.com/photo-1522337360788-8b13dee7a37e?auto=format&fit=crop&w=900&q=80",
  },
  {
    name: "Microneedling Scalp Therapy",
    pillar: "Hair & Scalp",
    duration: "60 min",
    from: "Consultation based",
    body: "Scalp microneedling delivered with a medical-grade pen and bespoke serum infusion — a collagen-induction protocol that may support scalp health, follicle environment and overall hair density. Sessions and any temporary side effects are discussed in private at consultation.",
    img: "https://customer-assets.emergentagent.com/job_derma-studio-2/artifacts/d4gi11nv_IMG_0517.jpeg",
  },
];

const PILLARS = ["All", "Skin & Aesthetics", "Weight Management", "Women's Health", "Hair & Scalp"];

export default function Treatments() {
  const [active, setActive] = React.useState("All");
  const filtered = active === "All" ? TREATMENTS : TREATMENTS.filter((t) => t.pillar === active);

  return (
    <section
      id="treatments"
      data-testid="treatments-section"
      className="py-24 md:py-32 px-6 md:px-12 lg:px-16 bg-[#FDFBF7]"
    >
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-12 gap-8 mb-12 md:mb-16 items-end">
          <div className="md:col-span-7">
            <p className="eyebrow mb-6">Four Pillars · One Studio</p>
            <h2 className="font-serif font-light text-4xl md:text-5xl leading-tight tracking-tight text-[#2D2926]">
              Integrated services for
              <br />
              <em className="italic text-[#C89F95]">considered, lasting</em> results.
            </h2>
          </div>
          <div className="md:col-span-5">
            <p className="text-[#5C5753] leading-relaxed font-light max-w-md">
              From advanced aesthetics to medical weight management, women's health and hair &amp;
              scalp therapy — every service begins with a private consultation and ends with a
              written plan you can actually follow.
            </p>
          </div>
        </div>

        {/* Pillar filter */}
        <div
          className="flex flex-wrap gap-2 mb-12 border-b border-[#E8DFD8] pb-6"
          data-testid="treatment-filters"
        >
          {PILLARS.map((p) => (
            <button
              key={p}
              onClick={() => setActive(p)}
              data-testid={`pillar-filter-${p.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
              className={`text-xs uppercase tracking-[0.22em] px-5 py-3 rounded-sm transition-colors ${
                active === p
                  ? "bg-[#2D2926] text-[#FDFBF7]"
                  : "text-[#5C5753] hover:text-[#2D2926] hover:bg-[#F5EFEB]"
              }`}
            >
              {p}
            </button>
          ))}
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-px bg-[#E8DFD8] border border-[#E8DFD8]">
          {filtered.map((t, i) => (
            <motion.a
              key={t.name}
              href="#book"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ duration: 0.6, delay: (i % 3) * 0.1 }}
              data-testid={`treatment-card-${i}`}
              className="group block bg-[#FDFBF7] hover:bg-white transition-colors"
            >
              <div className="aspect-[4/3] overflow-hidden relative">
                <img
                  src={t.img}
                  alt={t.name}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                />
                <span className="absolute top-4 left-4 eyebrow bg-[#FDFBF7]/85 backdrop-blur-sm px-3 py-1.5 text-[#5C5753]">
                  {t.pillar}
                </span>
              </div>
              <div className="p-8">
                <div className="flex items-start justify-between gap-4 mb-4">
                  <h3 className="font-serif text-2xl text-[#2D2926] leading-tight">{t.name}</h3>
                  <ArrowUpRight
                    size={18}
                    strokeWidth={1.25}
                    className="text-[#C89F95] mt-1 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform shrink-0"
                  />
                </div>
                <p className="text-sm text-[#5C5753] leading-relaxed font-light mb-6">{t.body}</p>
                <div className="flex justify-between items-center pt-4 border-t border-[#E8DFD8]">
                  <span className="eyebrow text-[#5C5753]">{t.duration}</span>
                  <span className="eyebrow text-[#C89F95]">{t.from}</span>
                </div>
              </div>
            </motion.a>
          ))}
        </div>
      </div>
    </section>
  );
}
